// ============================================
// COVRFLY UX - Bloque Envío v2.3.6 + Animación Sweet Spot 1.7s
// Fusión: diseño v2.3 + animación original
// ============================================
(function() {
  
  // 1) ELIMINAR TEXTO IVA
  document.querySelectorAll('.product__tax').forEach(el => el.style.display = 'none');
  
  // 2) CONFIGURACIÓN
  const CONFIG = {
    timezone: 'America/Mexico_City',
    cutOffHour: 16,
    urgencyThresholdHours: 8,  // T<=15: el contador SOLO cuenta al corte de HOY (visible 08-16h habiles; nunca '23h') — forense reloj original, Oscar 2026-07-14
    productionDays: 0,
    shipping: {
      standard: { name: 'Estándar', min: 7, max: 9 },   // 2 prod + 5-7 envio (= politica, Oscar 2026-07-14)
      priority: { name: 'Prioritario', min: 4, max: 6 },  // 2 prod + 2-4 envio
      express:  { name: 'Express', min: 2, max: 3 }       // 1 prod + 1-2 envio
    }
  };

  // 3) FESTIVOS MX
  const HOLIDAYS_FIXED = ['01-01','02-05','03-20','05-01','09-16','11-20','12-12','12-24','12-25','12-31'];
  
  function getEasterDates(year) {
    const a = year % 19, b = Math.floor(year / 100), c = year % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    const easter = new Date(year, month - 1, day);
    const jueves = new Date(easter); jueves.setDate(easter.getDate() - 3);
    const viernes = new Date(easter); viernes.setDate(easter.getDate() - 2);
    return [jueves, viernes];
  }

  function getHolidays(year) {
    const holidays = HOLIDAYS_FIXED.map(d => `${year}-${d}`);
    const [j, v] = getEasterDates(year);
    const fmt = d => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
    holidays.push(fmt(j), fmt(v));
    return holidays;
  }

  // 4) FUNCIONES FECHA
  function nowMX() { return new Date(new Date().toLocaleString('en-US', { timeZone: CONFIG.timezone })); }
  
  function isBiz(date) {
    const day = date.getDay();
    if (day === 0 || day === 6) return false;
    const y = date.getFullYear(), m = String(date.getMonth()+1).padStart(2,'0'), d = String(date.getDate()).padStart(2,'0');
    return !getHolidays(y).includes(`${y}-${m}-${d}`);
  }
  
  function nextBiz(date) { const x = new Date(date); do { x.setDate(x.getDate()+1); } while (!isBiz(x)); return x; }
  function addBiz(base, n) { let d = new Date(base), r = n; while (r > 0) { d.setDate(d.getDate()+1); if (isBiz(d)) r--; } return d; }
  
  function fmtRange(s, e) {
    const sd = s.getDate(), ed = e.getDate();
    const sm = new Intl.DateTimeFormat('es-MX',{month:'short'}).format(s).replace('.','');
    const em = new Intl.DateTimeFormat('es-MX',{month:'short'}).format(e).replace('.','');
    return sm === em ? `Llega ${sd}–${ed} ${em}` : `Llega ${sd} ${sm} – ${ed} ${em}`;
  }

  // 5) CALCULAR FECHAS — v2.3.5: funcion re-ejecutable; key = dia de arranque
  // (cambia exactamente al cruzar el corte 16:00 -> dispara re-render completo)
  function calcRanges() {
    let now = nowMX(), cutoff = new Date(now);
    cutoff.setHours(CONFIG.cutOffHour, 0, 0, 0);
    let start = now < cutoff ? now : nextBiz(now);
    if (!isBiz(start)) start = nextBiz(start);
    start.setHours(0,0,0,0);
    return {
      key: start.getTime(),
      std: { s: addBiz(start, CONFIG.shipping.standard.min), e: addBiz(start, CONFIG.shipping.standard.max) },
      pri: { s: addBiz(start, CONFIG.shipping.priority.min), e: addBiz(start, CONFIG.shipping.priority.max) },
      exp: { s: addBiz(start, CONFIG.shipping.express.min), e: addBiz(start, CONFIG.shipping.express.max) }
    };
  }
  let R = calcRanges();

  function getTimeToCutoff() {
    const n = nowMX(); let c = new Date(n);
    c.setHours(CONFIG.cutOffHour,0,0,0);
    if (n >= c) c = nextBiz(c);
    else if (!isBiz(n)) c = nextBiz(n);
    c.setHours(CONFIG.cutOffHour,0,0,0);
    const diff = c - n;
    return { hrs: Math.floor(diff/36e5), min: Math.floor((diff%36e5)/6e4), total: diff/36e5 };
  }

  // 6) RENDER BLOQUE ENVÍO v2.3
  const box = document.querySelector('.delivery-container');
  if (!box) { console.warn('⚠️ No .delivery-container'); return; }

  const ICONS = {
    truck: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>`,
    plane: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"/></svg>`,
    bolt: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>`
  };

  // v2.3.5: render re-ejecutable (carga + cruce de corte). dispatchEvent es
  // sincrono: preorden re-aplica su override en la misma tarea (cero parpadeo).
  // El tick de 30s NO pasa por aqui (solo repinta el texto del contador).
  function render() {
    const time = getTimeToCutoff();
    const showTimer = time.total <= CONFIG.urgencyThresholdHours;
    box.innerHTML = `
    <div class="cvr-header">
      ${showTimer ? `<div class="cvr-header-row"><span class="cvr-dot"></span><span class="cvr-header-text">Ordena en <strong id="cvr-countdown">${time.hrs > 0 ? time.hrs + "h " : ""}${time.min}m</strong> para recibir en:</span></div>` : `<span class="cvr-header-text">Entrega estimada:</span>`}
    </div>
    <div class="cvr-list">
      <div class="cvr-row"><div class="cvr-icon">${ICONS.truck}</div><div class="cvr-info"><div class="cvr-name">Estándar</div><div class="cvr-date">${fmtRange(R.std.s, R.std.e)}</div></div><div class="cvr-badge cvr-badge-free">Sin costo*</div></div>
      <div class="cvr-row"><div class="cvr-icon">${ICONS.plane}</div><div class="cvr-info"><div class="cvr-name">Prioritario</div><div class="cvr-date">${fmtRange(R.pri.s, R.pri.e)}</div></div></div>
      <div class="cvr-row"><div class="cvr-icon">${ICONS.bolt}</div><div class="cvr-info"><div class="cvr-name">Express</div><div class="cvr-date">${fmtRange(R.exp.s, R.exp.e)}</div></div><div class="cvr-badge cvr-badge-fast">Llega antes</div></div>
    </div>
    <div class="cvr-disclaimer">*Sin costo en 2+ cases \u00B7 Tiempos estimados</div>
  `;

    // v2.3.1 (2026-07-10): avisar que el bloque ya rendereo — el modulo de
    // preorden re-aplica su sobreescritura (mata la carrera de timing que
    // dejaba fechas hoy+N visibles en modelos en preorden).
    document.dispatchEvent(new CustomEvent('covrfly:delivery-rendered'));
  }
  render();

  // v2.3.5: RELOJ VIVO — tick de 30s: recalcula SIEMPRE contra la hora real
  // (nunca decrementa un valor guardado), y repinta solo el texto del contador.
  // Si cambia el dia de arranque (cruce del corte 16:00) o la visibilidad del
  // timer, re-render completo + evento (UNA vez). Pausa en pestana oculta y
  // resincroniza al volver (visibilitychange/focus).
  let tickId = null;
  function tick() {
    const nr = calcRanges();
    const t = getTimeToCutoff();
    const show = t.total <= CONFIG.urgencyThresholdHours;
    const el = document.getElementById('cvr-countdown');
    if (nr.key !== R.key || show !== !!el) { R = nr; render(); return; }
    if (el) el.textContent = `${t.hrs > 0 ? t.hrs + "h " : ""}${t.min}m`;
  }
  function startTicker() {
    if (tickId) clearInterval(tickId);
    tickId = setInterval(tick, 30000);
  }
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { if (tickId) { clearInterval(tickId); tickId = null; } }
    else { tick(); startTicker(); }
  });
  window.addEventListener('focus', tick);
  startTicker();

  // 7) CSS v2.3 + ANIMACIÓN SWEET SPOT 1.7s
  const css = `
    .delivery-container{opacity:1!important;line-height:normal!important;letter-spacing:0!important;font-style:normal!important;font-family:inherit!important;display:block!important;background:#fafafa!important;border:1px solid #e5e5e5!important;border-radius:16px!important;padding:16px 18px!important;max-width:100%!important;margin:0 0 16px 0!important;color:#1a1a1a!important;box-sizing:border-box!important}
    .cvr-header{padding-bottom:12px!important;border-bottom:1px solid #e5e5e5!important;margin-bottom:12px!important}
    .cvr-header-row{display:flex!important;align-items:center!important;gap:8px!important}
    .cvr-dot{width:8px!important;height:8px!important;background:#22c55e!important;border-radius:50%!important;display:inline-block!important;animation:cvr-pulse 2s infinite!important}
    @keyframes cvr-pulse{0%,100%{box-shadow:0 0 0 0 rgba(34,197,94,0.7)}50%{box-shadow:0 0 0 6px rgba(34,197,94,0)}}
    .cvr-header-text{font-size:13px!important;color:#1a1a1a!important;font-weight:600!important}
    .cvr-header-text strong{font-weight:600!important}
    .cvr-list{display:flex!important;flex-direction:column!important;gap:0!important}
    .cvr-row{display:flex!important;align-items:center!important;padding:12px 0!important;border-bottom:1px solid #f0f0f0!important;gap:12px!important}
    .cvr-row:last-child{border-bottom:none!important;padding-bottom:0!important}
    .cvr-row:first-child{padding-top:0!important}
    .cvr-icon{width:24px!important;height:24px!important;flex-shrink:0!important;display:flex!important;align-items:center!important;justify-content:center!important;color:#1a1a1a!important}
    .cvr-icon svg{width:20px!important;height:20px!important}
    .cvr-info{flex:1!important;min-width:0!important}
    .cvr-name{font-size:14px!important;font-weight:600!important;color:#1a1a1a!important;line-height:1.3!important}
    .cvr-date{font-size:12px!important;color:#525252!important;margin-top:2px!important}
    .cvr-badge{font-size:11px!important;font-weight:500!important;padding:4px 10px!important;border-radius:99px!important;white-space:nowrap!important}
    .cvr-badge-free{background:#dcfce7!important;color:#166534!important}
    .cvr-badge-fast{background:#FEF3C7!important;color:#CA8A04!important}
    .cvr-disclaimer{margin-top:12px!important;padding-top:10px!important;border-top:1px solid #f0f0f0!important;font-size:11px!important;color:#a3a3a3!important;text-align:center!important}
    .product-form__submit,.product-form__submit.button,button[name="add"]{width:100%!important;max-width:100%!important;height:52px!important;background:#0470E3!important;color:#fff!important;border:none!important;border-radius:12px!important;font-size:16px!important;font-weight:600!important;display:flex!important;align-items:center!important;justify-content:center!important;gap:8px!important;cursor:pointer!important}
    .product__add__cart__button,.product-form__buttons,.product-form__cart--box{width:100%!important}
  `;
  
  let styleEl = document.getElementById('cvr-css');
  if (styleEl) styleEl.remove();
  styleEl = document.createElement('style');
  styleEl.id = 'cvr-css';
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  // 8) BLOQUE YA EN POSICIÓN CORRECTA VIA LIQUID (block_order)
  // insertBefore() eliminado — el delivery-container ya nace antes del CTA

  console.log('✅ COVRFLY Bloque Envío v2.3 + Animación 1.7s');


  // Anti-FOUC v2.0: señal al orquestador
  window.cfPdpDone && window.cfPdpDone('delivery');

})();
